


































import { Vue, Component, Prop } from 'vue-property-decorator';
import charts from './charts';

import { Mutation, Action, State, Getter } from 'vuex-class';

@Component({
  components: { ...charts },
})
export default class DashboardItem extends Vue {
  @Mutation('DELETE_COMP') private DELETE_COMP: any;
  @Mutation('SWICH_COMP') private SWICH_COMP: any;
  @State('rocketDashboard') private rocketDashboard: any;
  @Getter('intervalTime') private intervalTime: any;
  @Prop() private rocketGlobal!: any;
  @Prop() private i!: any;
  @Prop() private index!: number;
  @Prop() private dragIndex!: number;
  private drop() {
    this.SWICH_COMP({start: this.dragIndex, end: this.index});
  }
}

